import { useCallback, useEffect, useState } from 'react';
import { api } from '../../api';
import { ApiError, type Friend } from '../../api/types';
import { t } from '../../i18n/idioma';

const INTERVALO = 60_000;

/**
 * Lista fora da janela: o ponto do menu e o tell de amigo precisam dela
 * mesmo com Amigos fechado.
 */
export function useAmigos(ativo: boolean) {
  const [amigos, setAmigos] = useState<readonly Friend[]>([]);
  const [erro, setErro] = useState<string | null>(null);

  const recarregar = useCallback(async () => {
    try {
      setAmigos(await api.listFriends());
      setErro(null);
    } catch (err) {
      setErro(err instanceof ApiError ? err.message : t('amigo.naoLeu'));
    }
  }, []);

  useEffect(() => {
    void recarregar();
    const id = window.setInterval(() => { void recarregar(); }, INTERVALO);
    return () => window.clearInterval(id);
  }, [recarregar]);

  useEffect(() => {
    if (ativo) void recarregar();
  }, [ativo, recarregar]);

  return { amigos, erro, recarregar };
}
